export enum AiFillConfigGenerateAs {
  Keywords = 'KEYWORDS',
  Summary = 'SUMMARY',
  ActionItems = 'ACTION_ITEMS',
}
export enum AiFillConfigGroupBy {
  None = 'NONE',
  Participants = 'PARTICIPANTS',
  Company = 'COMPANY',
  Topics = 'TOPIC',
}
export enum AiFillConfigTextLength {
  Short = 'SHORT',
  Medium = 'MEDIUM',
  Long = 'LONG',
}
export enum AiFillConfigFormatAs {
  Paragraph = 'PARAGRAPH',
  BulletList = 'BULLETED_LIST',
  NumberedList = 'NUMBERED_LIST',
  Checklist = 'CHECKLIST',
  Tasks = 'TASKS',
}
export enum AiFillConfigTone {
  Casual = 'CASUAL',
  Neutral = 'NEUTRAL',
  Professional = 'PROFESSIONAL',
}
export enum AiFillConfigCreateTaskFor {
  AllMembers = 'ALL_MEMBERS',
  NativeMembers = 'NATIVE',
  ExternalMembers = 'EXTERNAL',
}
export interface AiFillConfig {
  title: string;
  goal: string;
  generateAs: AiFillConfigGenerateAs;
  groupBy?: AiFillConfigGroupBy;
  textLength?: AiFillConfigTextLength;
  formatAs?: AiFillConfigFormatAs;
  tone?: AiFillConfigTone;
  staticKeywords?: string[];
  selectFieldsToPullKeywordsFrom?: string[];
  createTasksFor?: AiFillConfigCreateTaskFor;
}
export interface CustomAiFillApp {
  aiFillAppId: number;
  aiFillAppConfig: AiFillConfig;
  createdBy: number;
  isDefault: false | undefined;
}
export interface DefaultAiFillApp {
  aiFillAppConfig: AiFillConfig;
  defaultAiFillAppIdentifier: string;
  isDefault: true;
}
export enum AiFillAppDestination {
  Document = 'DOCUMENT',
  DocumentTemplate = 'DOCUMENT_TEMPLATE',
  ProjectUpdate = 'PROJECT_UPDATE',
}
export enum AiFillAppInput {
  Meeting = 'MEETING',
}
export type AiFillApp = DefaultAiFillApp | CustomAiFillApp;
export type SourceForResolvingApp = { sourceId: number; sourceType: string };
export type ContentReceivedCallback = (data: string) => void;
export type ResolveAppParams = {
  appId: number | string;
  sources: SourceForResolvingApp[];
  destination: AiFillAppDestination;
  onContentReceived: ContentReceivedCallback;
};
